// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__0lwhG","active":"styles_active__8JgEr","inactive":"styles_inactive__PACOt"};